import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 4 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 15.269q-.62 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.06.442-.44 1.06-.44.62 0 1.06.44.44.441.44 1.06t-.44 1.06q-.44.44-1.06.44m0-5.77q-.62 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.059Q1.383 6.5 2 6.5q.62 0 1.06.44T3.5 8q0 .618-.44 1.059T2 9.499M2 3.73q-.62 0-1.06-.44A1.45 1.45 0 0 1 .5 2.23q0-.618.44-1.059.442-.44 1.06-.44.62 0 1.06.44t.44 1.06q0 .618-.44 1.059T2 3.73"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
